const locale = {
  ButtonAddLocation: "Thêm địa điểm",
  Weather: "Dự báo thời tiết",
  Weather72h: "Thời tiết 72h tới",
  Weather24h: "Thời tiết 24h tới",
  Chart72h: "Đồ thị dự báo 72h tới",
  Chart24h: "Đồ thị dự báo 24h tới",
  Weather14Day: "Thời tiết 14 ngày",
  Weather5Day: "Thời tiết 5 ngày",
  "Forecast information": "Thông tin dự báo",
  Report: "Báo cáo",
  Location: "Địa điểm",
  "Choose Location": "Chọn địa điểm",
  Humidity: "Độ ẩm",
  Wind: "Tốc độ gió",
  "Probability Rain": "Khả năng mưa",
  Precipitation: "Lượng mưa",
  RealFeel: "Cảm giác như",
  Normal: "Bình thường",
  Warning: "Cảnh báo",
  Dangerous: "Nguy hiểm",
  "Cloud cover": "Độ bao phủ mây",
  PreviewReport: "Xem trước báo cáo",
  CancelTextPreviewReport: "Hủy",
  NoData: "Không có dữ liệu",
  Date: "Ngày",
  ReportTableTitleDate: "Thời gian",
  ReportTableTitleFileName: "Tên file",
  ReportTableTitleFileDownload: "Tải file",
  ReportTableTitleAction: "Tác vụ",

  CreateTitleHeader: "Thêm mới địa điểm",
  ButtonCancel: "Hủy bỏ",
  ButtonCreate: "Thêm điểm",
  PlaceholderAddress: "Nhập địa điểm bạn muốn tìm kiếm",
};

export default locale;
